import Plyr from 'plyr/dist/plyr.polyfilled.js';
import $ from 'jquery';

$(function(){
    const $videos = document.querySelectorAll('.cs-vid');

    if ($videos) {
		$videos.forEach($video => {
			const $videoPlayer = $video.querySelector('video');
			const $playBtn = $video.querySelector('.cs-vid__play-btn');
			let player = null;

			const initVideo = () => {
				const {poster} = $videoPlayer.dataset;

				player = new Plyr($videoPlayer, {
					controls: ['play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen'],
					muted: $videoPlayer.muted
				});

				if ($playBtn) {
					$playBtn.addEventListener('click', () => {
						player.play();
					});
				}

				if (poster) {
					player.on('ready', () => {
						player.poster = poster;
					});
				}
			};

			const autoplayVideoOnScreen = () => {
				requestAnimationFrame(() => {
					if (!player) return;

					if ($videoPlayer.classList.contains('autoplay')) {
						const { y } = $videoPlayer.getBoundingClientRect();

						if (y - window.innerHeight < 0 && y + $videoPlayer.offsetHeight > 0) {
							player.play();
						} else {
							player.stop();
						}
					}
				});
			}

			window.addEventListener('scroll', autoplayVideoOnScreen);

			initVideo();
			autoplayVideoOnScreen();
		});
	}

	// carousels
	$('.cs-caro').each(function(){
		
		var $container = $(this).find('.caro');
		var $carousel = $container.find('.slides');
		var controls = $container.hasClass('controls');
		var autoplay = $container.hasClass('autoplay');
		var autoplaySpeed = 0;
		if(autoplay) autoplaySpeed = $container.data('autoplay-speed');
		var pauseOnHover = (controls) ? true : false;
		var pauseOnFocus = (controls) ? true : false;
		
		$carousel.slick({
			autoplay: autoplay,
			autoplaySpeed: autoplaySpeed,
			arrows: false,
			pauseOnHover: pauseOnHover,
			pauseOnFocus: pauseOnFocus
		});
		
		if(controls) {
			$container.find('.arrow.left').click(function(e){
				e.preventDefault();
				$carousel.slick('slickPrev');
			});
			$container.find('.arrow.right').click(function(e){
				e.preventDefault();
				$carousel.slick('slickNext');
			});
			$container.find('.dots a').click(function(e){
				e.preventDefault();
				var newSlide = $container.find('.dots a').index($(this));
				$carousel.slick('slickGoTo', newSlide);
			});
			$carousel.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
				$container.find('.dots a').removeClass('active');
				$container.find('.dots a').eq(nextSlide).addClass('active');
			});
		}
		
	});
	
	
	
	// "crop" videos in dual-block layout to square
	$('.cs-dual .video').each(function(){
		var $vid = $(this).find('video');
		var vidInitTimer = setInterval(function(){
			if($vid[0].readyState >= 3){
				if($vid.width() >= $vid.height()) $vid.addClass('landscape');
				else $vid.addClass('portrait');
				clearInterval(vidInitTimer);
			}
		}, 100);
	});
	
});


// hack to get autoplay videos preloading in iOS
$(window).on("load", function(){
	$('.cs-vid video.autoplay').each(function(){	
		var $vid = $(this);
		var $container = $vid.parent();
		var hasSound = !$vid[0].muted;
		if(hasSound) $vid[0].muted = true;
		$vid[0].play();
		setTimeout(function(){
			if(!$container.hasClass('playing')) {
				$vid[0].pause();
				$vid[0].currentTime = 0;
			}
			if(hasSound) $vid[0].muted = false;
		}, 100);
	});
});